
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  emits: ['mounted'],
  props: {
    my: { type: Boolean, default: false },
    isPhoto: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    onMounted(() => {
      emit('mounted');
    });

    return { };
  },
});
